import { render, staticRenderFns } from "./KioskLifecycle.vue?vue&type=template&id=0aab8660"
import script from "./KioskLifecycle.vue?vue&type=script&lang=js"
export * from "./KioskLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aab8660')) {
      api.createRecord('0aab8660', component.options)
    } else {
      api.reload('0aab8660', component.options)
    }
    module.hot.accept("./KioskLifecycle.vue?vue&type=template&id=0aab8660", function () {
      api.rerender('0aab8660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/kiosk/KioskLifecycle.vue"
export default component.exports